import { styled } from "@mui/material";
import { MenuItem } from "../../Menu";

export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    gap: ${(props) => props.theme.wsc.spacing[0]};
  }
`;
